import { Link } from "gatsby";
import React from "react";
import { motion, spring } from "framer-motion";

export default function LetsChat() {
  return (
    <>
      <motion.div
        initial={{ x: 800, y: 100 }}
        animate={{ x: 100, y: 100 }}
        transition={{
          duration: 2,
          delay: 4,
          type: spring,
          bounce: 0.4,
        }}
        className="hidden md:block md:fixed bottom-8 right-4 md:bottom-20 md:right-20 z-50"
      >
        <Link to="/contact-us#contactForm" aria-label="Let's chat">
          <svg
            aria-hidden="true"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            className="fixed bottom-8 right-4 md:bottom-16 md:right-16 z-50 w-32 h-32 outline outline-[#3F04F6] bg-[#3F04F6] rounded-full hover:rotate-180 duration-700 ease-in-out"
          >
            <path
              id="circlePath"
              fill="none"
              strokeWidth="0"
              stroke="none"
              d=" M 18, 50
                  a 32,32 0 1,1 64,0
                  32,32 0 1,1 -64,0"
            />
            <path
              id="circlePath2"
              fill="none"
              strokeWidth="0"
              stroke="none"
              d=" M 18, 50
                  a 32,32 0 1,1 64,0
                  32,32 0 1,1 -64,0"
            />
            <svg
              aria-hidden="true"
              width="100"
              height="100"
              viewBox="0 0 156 155"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="77.9379" cy="77.1088" r="77.1088" fill="#3F04F6" />
              <path
                d="M78.7167 48C62.8587 48 50 60.8553 50 76.7133C50 81.8534 52.9821 89.059 52.9821 89.059C53.3891 90.044 53.7071 90.9126 53.6866 90.9913C53.6661 91.0699 53.4301 91.9762 53.1634 93.009L50.3693 103.771C50.1026 104.804 50.7216 105.416 51.751 105.132L62.4689 102.171C63.4983 101.887 64.3601 101.648 64.3874 101.641C64.4148 101.634 65.2424 101.962 66.2273 102.376C66.2273 102.376 73.5151 105.43 78.7133 105.43C94.5713 105.43 107.427 92.5747 107.427 76.7167C107.427 60.8587 94.5747 48 78.7167 48ZM66.0597 80.3042C64.1549 80.3042 62.6091 78.7584 62.6091 76.8535C62.6091 74.9486 64.1549 73.4028 66.0597 73.4028C67.9646 73.4028 69.5104 74.9486 69.5104 76.8535C69.5104 78.7584 67.9646 80.3042 66.0597 80.3042ZM78.6586 80.3042C76.7537 80.3042 75.2079 78.7584 75.2079 76.8535C75.2079 74.9486 76.7537 73.4028 78.6586 73.4028C80.5634 73.4028 82.1092 74.9486 82.1092 76.8535C82.1092 78.7584 80.5634 80.3042 78.6586 80.3042ZM91.466 80.3042C89.5611 80.3042 88.0154 78.7584 88.0154 76.8535C88.0154 74.9486 89.5611 73.4028 91.466 73.4028C93.3709 73.4028 94.9167 74.9486 94.9167 76.8535C94.9167 78.7584 93.3709 80.3042 91.466 80.3042Z"
                fill="white"
              />
              <path
                d="M78.7167 48C62.8587 48 50 60.8553 50 76.7133C50 81.8534 52.9821 89.059 52.9821 89.059C53.3891 90.044 53.7071 90.9126 53.6866 90.9913C53.6661 91.0699 53.4301 91.9762 53.1634 93.009L50.3693 103.771C50.1026 104.804 50.7216 105.416 51.751 105.132L62.4689 102.171C63.4983 101.887 64.3601 101.648 64.3874 101.641C64.4148 101.634 65.2424 101.962 66.2273 102.376C66.2273 102.376 73.5151 105.43 78.7133 105.43C94.5713 105.43 107.427 92.5747 107.427 76.7167C107.427 60.8587 94.5747 48 78.7167 48ZM66.0597 80.3042C64.1549 80.3042 62.6091 78.7584 62.6091 76.8535C62.6091 74.9486 64.1549 73.4028 66.0597 73.4028C67.9646 73.4028 69.5104 74.9486 69.5104 76.8535C69.5104 78.7584 67.9646 80.3042 66.0597 80.3042ZM78.6586 80.3042C76.7537 80.3042 75.2079 78.7584 75.2079 76.8535C75.2079 74.9486 76.7537 73.4028 78.6586 73.4028C80.5634 73.4028 82.1092 74.9486 82.1092 76.8535C82.1092 78.7584 80.5634 80.3042 78.6586 80.3042ZM91.466 80.3042C89.5611 80.3042 88.0154 78.7584 88.0154 76.8535C88.0154 74.9486 89.5611 73.4028 91.466 73.4028C93.3709 73.4028 94.9167 74.9486 94.9167 76.8535C94.9167 78.7584 93.3709 80.3042 91.466 80.3042Z"
                stroke="white"
                strokeWidth="0.341988"
                strokeMiterlimit="10"
              />
            </svg>

            <text
              id="text"
              fontSize="12"
              fontWeight="normal"
              fill="#fff"
              radius="20"
            >
              <textPath id="textPath" href="#circlePath" startOffset="46">
                Let's chat
              </textPath>
            </text>
            <text
              id="text"
              fontSize="12"
              fontWeight="normal"
              fill="#fff"
              radius="20"
            >
              <textPath id="textPath" href="#circlePath2" startOffset="146">
                Let's chat
              </textPath>
            </text>
          </svg>{" "}
        </Link>
      </motion.div>

      <motion.div
        initial={{ x: 800, y: 100 }}
        animate={{ x: 100, y: 100 }}
        transition={{
          duration: 2,
          delay: 4,
          type: spring,
          bounce: 0.4,
        }}
        className="fixed md:hidden bottom-24 right-28 z-50"
        role="chat with us"
      >
        <Link to="/contact-us#contactForm" aria-label="Let's chat">
          <svg
            aria-hidden="true"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            className="fixed bottom-8 right-4 z-50 w-16 h-16 outline outline-[#3F04F6] bg-[#3F04F6] rounded-full hover:rotate-180 duration-700 ease-in-out"
          >
            <path
              id="circlePath"
              fill="none"
              strokeWidth="0"
              stroke="none"
              d=" M 18, 50
                  a 32,32 0 1,1 64,0
                  32,32 0 1,1 -64,0"
            />
            <path
              id="circlePath2"
              fill="none"
              strokeWidth="0"
              stroke="none"
              d=" M 18, 50
                  a 32,32 0 1,1 64,0
                  32,32 0 1,1 -64,0"
            />
            <svg
              aria-hidden="true"
              width="150"
              height="150"
              viewBox="25 25 156 155"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="77.9379" cy="77.1088" r="77.1088" fill="#3F04F6" />
              <path
                d="M78.7167 48C62.8587 48 50 60.8553 50 76.7133C50 81.8534 52.9821 89.059 52.9821 89.059C53.3891 90.044 53.7071 90.9126 53.6866 90.9913C53.6661 91.0699 53.4301 91.9762 53.1634 93.009L50.3693 103.771C50.1026 104.804 50.7216 105.416 51.751 105.132L62.4689 102.171C63.4983 101.887 64.3601 101.648 64.3874 101.641C64.4148 101.634 65.2424 101.962 66.2273 102.376C66.2273 102.376 73.5151 105.43 78.7133 105.43C94.5713 105.43 107.427 92.5747 107.427 76.7167C107.427 60.8587 94.5747 48 78.7167 48ZM66.0597 80.3042C64.1549 80.3042 62.6091 78.7584 62.6091 76.8535C62.6091 74.9486 64.1549 73.4028 66.0597 73.4028C67.9646 73.4028 69.5104 74.9486 69.5104 76.8535C69.5104 78.7584 67.9646 80.3042 66.0597 80.3042ZM78.6586 80.3042C76.7537 80.3042 75.2079 78.7584 75.2079 76.8535C75.2079 74.9486 76.7537 73.4028 78.6586 73.4028C80.5634 73.4028 82.1092 74.9486 82.1092 76.8535C82.1092 78.7584 80.5634 80.3042 78.6586 80.3042ZM91.466 80.3042C89.5611 80.3042 88.0154 78.7584 88.0154 76.8535C88.0154 74.9486 89.5611 73.4028 91.466 73.4028C93.3709 73.4028 94.9167 74.9486 94.9167 76.8535C94.9167 78.7584 93.3709 80.3042 91.466 80.3042Z"
                fill="white"
              />
              <path
                d="M78.7167 48C62.8587 48 50 60.8553 50 76.7133C50 81.8534 52.9821 89.059 52.9821 89.059C53.3891 90.044 53.7071 90.9126 53.6866 90.9913C53.6661 91.0699 53.4301 91.9762 53.1634 93.009L50.3693 103.771C50.1026 104.804 50.7216 105.416 51.751 105.132L62.4689 102.171C63.4983 101.887 64.3601 101.648 64.3874 101.641C64.4148 101.634 65.2424 101.962 66.2273 102.376C66.2273 102.376 73.5151 105.43 78.7133 105.43C94.5713 105.43 107.427 92.5747 107.427 76.7167C107.427 60.8587 94.5747 48 78.7167 48ZM66.0597 80.3042C64.1549 80.3042 62.6091 78.7584 62.6091 76.8535C62.6091 74.9486 64.1549 73.4028 66.0597 73.4028C67.9646 73.4028 69.5104 74.9486 69.5104 76.8535C69.5104 78.7584 67.9646 80.3042 66.0597 80.3042ZM78.6586 80.3042C76.7537 80.3042 75.2079 78.7584 75.2079 76.8535C75.2079 74.9486 76.7537 73.4028 78.6586 73.4028C80.5634 73.4028 82.1092 74.9486 82.1092 76.8535C82.1092 78.7584 80.5634 80.3042 78.6586 80.3042ZM91.466 80.3042C89.5611 80.3042 88.0154 78.7584 88.0154 76.8535C88.0154 74.9486 89.5611 73.4028 91.466 73.4028C93.3709 73.4028 94.9167 74.9486 94.9167 76.8535C94.9167 78.7584 93.3709 80.3042 91.466 80.3042Z"
                stroke="white"
                strokeWidth="0.341988"
                strokeMiterlimit="10"
              />
            </svg>
          </svg>{" "}
        </Link>
      </motion.div>
    </>
  );
}
